import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    container: 'f-col p-4 space-y-1',
    ctaContainer: 'f-col gap-1 pb-1 not-first:pt-1 md:(flex-row wrap)'
  }
} satisfies CMSConfig['linkedCard']
